import { OptionItem } from '../../../diagram/utils/option-item';
import { ConditionCombine } from './enum/condition-combine';
var ConditionCombineHelper = /** @class */ (function () {
    function ConditionCombineHelper() {
    }
    ConditionCombineHelper.getConditionCombines = function () {
        return [
            new OptionItem(ConditionCombine.None, 'Nothing'),
            new OptionItem(ConditionCombine.And, 'And'),
            new OptionItem(ConditionCombine.Or, 'Or')
        ];
    };
    return ConditionCombineHelper;
}());
export { ConditionCombineHelper };
